import { useState, useRef } from 'react';
import { ArticleList } from './ArticleList';
import { ArticleEditor } from './ArticleEditor';
import type { Article } from '../../types';

type View = 'list' | 'editor';

interface ArticlesConfigProps {
  userUid?: string;
  isAdmin: boolean;
}

export function ArticlesConfig({ userUid, isAdmin }: ArticlesConfigProps) {
  const [view, setView] = useState<View>('list');
  const [editingArticle, setEditingArticle] = useState<Article | null>(null);
  const savedScrollY = useRef(0);

  const handleEdit = (article: Article) => {
    savedScrollY.current = window.scrollY;
    setEditingArticle(article);
    setView('editor');
    window.scrollTo(0, 0);
  };

  const handleCreate = () => {
    savedScrollY.current = window.scrollY;
    setEditingArticle(null);
    setView('editor');
    window.scrollTo(0, 0);
  };

  const handleBack = () => {
    setEditingArticle(null);
    setView('list');
    requestAnimationFrame(() => window.scrollTo(0, savedScrollY.current));
  };

  const handleSaved = () => {
    handleBack();
  };

  return (
    <div>
      {view === 'list' && (
        <ArticleList
          userUid={userUid}
          isAdmin={isAdmin}
          onEdit={handleEdit}
          onCreate={handleCreate}
        />
      )}
      {view === 'editor' && (
        <ArticleEditor
          key={editingArticle?.id ?? 'new'}
          article={editingArticle}
          userUid={userUid}
          isAdmin={isAdmin}
          onBack={handleBack}
          onSaved={handleSaved}
        />
      )}
    </div>
  );
}
